import * as React from 'react';
import {
  DefaultButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  PrimaryButton,
  Typography,
  makeStyles,
} from '@bb-ui/react-library';
import { useTranslation } from 'react-i18next';
import { ReleaseStageMember } from './ReleaseStageMembers.types';

const useStyles = makeStyles(() => ({
  memberList: {
    maxHeight: 240,
    overflowY: 'auto',
    marginBottom: 0,
  },
}));

export interface ReleaseStageUnlockConfirmationDialogProps {
  id: string;
  open: boolean;
  members: ReleaseStageMember[];
  submitting?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ReleaseStageUnlockConfirmationDialog: React.FC<
  ReleaseStageUnlockConfirmationDialogProps
> = ({ id, open, members, submitting, onConfirm, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog
      id={id}
      open={open}
      onClose={onClose}
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-description`}
    >
      <DialogTitle id={`${id}-title`} onClose={onClose} closeLabel={t('global.close')}>
        {t('releaseStageMembers.unlockConfirmation.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={`${id}-description`}>
          {t('releaseStageMembers.unlockConfirmation.summary', { count: members.length })}
        </DialogContentText>
        <ul
          className={classes.memberList}
          aria-label={t('releaseStageMembers.unlockConfirmation.list')}
        >
          {members.map((member) => (
            <li key={member.TenantId}>
              <Typography variant="body2">
                {member.Url ?? member.TenantName} ({member.TenantId})
              </Typography>
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <PrimaryButton disabled={submitting || members.length === 0} onClick={onConfirm}>
          {t('releaseStageMembers.unlockConfirmation.confirm', { count: members.length })}
        </PrimaryButton>
        <DefaultButton disabled={submitting} onClick={onClose}>
          {t('global.cancel')}
        </DefaultButton>
      </DialogActions>
    </Dialog>
  );
};
